<template>
  <span class="file-selector__slot" @click="onSelectFile">
    <slot />
  </span>
  <input ref="fileInput" type="file" :accept="acceptedFiles" @change="onFileChange" v-show="false" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

/**
 * Component that contains a hidden file input that has the visible component slotted into it
 */

const props = defineProps<{
  accept: string[]
}>()

const emits = defineEmits<{
  (event: 'fileSelected', file: File): void
}>()

const acceptedFiles = computed(() => props.accept.join(','))

const fileInput = ref<HTMLInputElement | null>(null)

const onSelectFile = () => {
  if (fileInput.value) {
    fileInput.value.click()
  }
}

const onFileChange = () => {
  if (fileInput.value) {
    if (fileInput.value.files && fileInput.value.files.length === 1) {
      const file = fileInput.value.files.item(0)
      if (file) {
        emits('fileSelected', file)
      }
    }
    // Resets the input value to allow consecutive reuploads of a file
    fileInput.value.value = ''
  }
}

</script>
